import { render, staticRenderFns } from "./SfMegaMenu.vue?vue&type=template&id=41c8c972&"
import script from "./SfMegaMenu.vue?vue&type=script&lang=js&"
export * from "./SfMegaMenu.vue?vue&type=script&lang=js&"
import style0 from "./SfMegaMenu.vue?vue&type=style&index=0&id=41c8c972&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports